// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-fixed .price-wallet[data-v-21aa454e],.header-fixed .price-wallet i[data-v-21aa454e]{color:#001554}.price-wallet[data-v-21aa454e]{padding-right:12px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:6px!important;background-color:hsla(0,0%,100%,.2);-webkit-box-flex:1;-ms-flex:1 0 0px;flex:1 0 0}.price-walletButton[data-v-21aa454e]{border-radius:6px 0 0 6px!important}", ""]);
// Exports
module.exports = exports;
